<template>
    <el-dialog
            width="300px"
            :visible.sync="isShow"
            :modal-append-to-body="false"
            :show-close="true"
            :close-on-click-modal="true"
            :close-on-press-escape="true"
            title="请设置归还时间"
            custom-class="return_dialog_class"
    >
        <div>
            <p>您将为已选中的样品进行归还操作</p>
            <div  style="display: flex;">
                <div style="line-height: 30px;">归还时间: </div>
                <div>
                    <el-date-picker
                            v-model="return_time"
                            size="small"
                            type="datetime"
                            placeholder="选择日期时间">
                    </el-date-picker>
                </div>
            </div>
        </div>
        <div slot="footer" class="group-edit-footer">
            <el-button size="small" @click="isShow = false">取 消</el-button>
            <el-button size="small" type="primary" @click="save" v-loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {lend} from "@/api/toy/lend";
    export default {
        name: "ReturnAll",
        data(){
            return {
                loading: false,
                return_time: '',
            }
        },
        props:{
            /**
             * 是否显示
             */
            show: {
                default: false,
                value: Boolean,
            },
            /**
             * 归还IDS
             */
            ids: {
                default: [],
                value: Object,
            },
            search: {
                default: [],
                value: Object,
            },
            isCheckAll: {
                default: false,
                value: Boolean,
            }
        },
        methods:{
            save(){
                if(this.return_time.length<1){
                    this.$message.error("未设置归还时间");
                    return;
                }
                if(!this.show){
                    return;
                }
                this.loading = true;
                if(this.isCheckAll){
                    lend.returnAllLend({
                        search: this.search,
                        return_time: this.return_time
                    }).then(res => {
                        if(res.code==0){
                            this.$emit("save", [], this.return_time);
                        }else{
                            this.$message.error(res.msg);
                        }
                    }).finally(()=>{
                        this.loading = false;
                    });
                }else {
                    console.log("AA");
                    let data = this.ids;
                    let return_time = this.return_time;
                    let oks = [];
                    let errs = [];
                    let proArr = [];
                    for (let i = 0; i < data.length; i++) {
                        proArr.push(new Promise(function (resolve, reject) {
                            lend.edit({
                                id: data[i].id,
                                return_time: return_time
                            }).then(res => {
                                res.d = data[i];
                                resolve(res);
                            }).catch(err => {
                                err.d = data[i];
                                reject(err);
                            })
                        }));
                    }
                    Promise.all(proArr).then(res => {
                        this.loading = false;
                        //console.log(res);
                        for (let i = 0; i < res.length; i++) {
                            if (res[i].code == 0) {
                                oks.push(res[i].d);
                            } else {
                                errs.push(res[i].d);
                            }
                        }
                        this.$emit("save", oks, return_time);
                    }).catch((err) => {
                        console.log(err);
                    })
                }
            }
        },
        computed: {
            isShow: {
                get() {
                    return this.show;
                },
                set(v) {
                    this.$emit("update:show", v);
                }
            }
        }
    }
</script>
<style lang="scss">
    .return_dialog_class{
        .el-dialog__header{
            border-bottom: solid 1px #ccc;
            .el-dialog__title{
                font-size: 15px;
                line-height: 20px;
                font-weight: bold;
            }
        }
    }
</style>

<style scoped>

</style>